import { Link, Paper, Skeleton } from '@mui/material';
import { CoreBox, CoreTypography } from '@youscience/core';
import { CONTACT_SUPPORT_URL } from '@components/ui/ErrorPages/constants';

export const CcrMFELoadingSkeleton = () => (
  <CoreBox sx={{ maxWidth: 'calc(1240px + 2.5rem)', width: '100%', py: 2 }}>
    {/* Page title */}
    <Skeleton variant='text' width='55%' height={42} sx={{ mb: 2 }} />

    {/* Toggle row */}
    <CoreBox sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, px: 2 }}>
      <Skeleton variant='rectangular' width={58} height={38} sx={{ borderRadius: '19px' }} />
      <Skeleton variant='text' width='45%' height={28} />
    </CoreBox>

    {/* Date fields */}
    <CoreBox sx={{ display: 'flex', gap: 2, px: 7, mb: 3 }}>
      <Skeleton variant='rectangular' width={140} height={56} sx={{ borderRadius: 1 }} />
      <Skeleton variant='rectangular' width={140} height={56} sx={{ borderRadius: 1 }} />
    </CoreBox>

    {/* Card section */}
    <Paper sx={{ p: 3, borderRadius: '12px', boxShadow: '0px 8px 24px -4px rgba(0,0,0,0.08)' }}>
      <CoreBox sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Skeleton variant='text' width='25%' height={32} />
        <Skeleton variant='rectangular' width={180} height={40} sx={{ borderRadius: '20px' }} />
      </CoreBox>
      <Skeleton variant='text' width='75%' height={20} />
    </Paper>
  </CoreBox>
);

export const CcrMFEUnavailable = () => (
  <CoreBox
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 10,
      px: 4,
      textAlign: 'center',
    }}
  >
    <CoreTypography variant='h4' sx={{ fontWeight: 700, mb: 2 }}>
      This page is currently unavailable
    </CoreTypography>
    <CoreTypography sx={{ color: 'text.secondary', maxWidth: 480, mb: 1 }}>
      We&apos;re unable to load the CCR configuration right now. Please try refreshing the page or come back later.
    </CoreTypography>
    <CoreTypography sx={{ fontSize: '14px', fontWeight: 500, mt: 3 }}>
      Need help?{' '}
      <Link href={CONTACT_SUPPORT_URL} color='secondary' target='_blank' rel='noopener noreferrer'>
        Contact Support
      </Link>
    </CoreTypography>
  </CoreBox>
);
